export const ColumnsLocalAccount = [
  {
    Header: ".",
    columns: [
      {
        Header: "Account Name",
        accessor: "name",
      },
      {
        Header: "Currency",
        accessor: "currency",
      },
      {
        Header: "Bank Account Number",
        accessor: "accountnumber",
      },
      {
        Header: "Bank Name",
        accessor: "bankname",
      },

      {
        Header: "Country",
        accessor: "country",
      },
    ],
  },
];
export const ColumnsForeignAccount = [
  {
    Header: ".",
    columns: [
      {
        Header: "Account Name",
        accessor: "name",
      },
      {
        Header: "Currency",
        accessor: "currency",
      },
      {
        Header: "IBAN",
        accessor: "iban",
      },
      {
        Header: "SWIFT CODE",
        accessor: "swiftcode",
      },
      {
        Header: "Bank Name",
        accessor: "bankname",
      },
      {
        Header: "Bank Opening branch",
        accessor: "bankopeningbranch",
      },
      {
        Header: "Country",
        accessor: "country",
      },
    ],
  },
];
